module.exports = __webpack_public_path__ + "media/images/home/concept_scene_4-8514269fad010083b6160e5c4e801dde.png";